import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as Spinner } from './images/spinner.svg';
import { ReactComponent as XIcon } from './images/x.svg';
import { ReactComponent as CheckIcon } from './images/check.svg';

const getCurrentPage = () => {
  let url = window.location.href;
  let page = url.split('/').pop();
  return '/' + page;
}

const Tab = ({ text, page, onClick, status }) => {
  const navigate = useNavigate();

  return (
    <div style={{ backgroundColor: getCurrentPage() === page ? '#0098e1' : 'gray',
                  borderRadius: '2px',
                  padding: '10px 20px',
                  fontSize: 20,
                  cursor: 'pointer',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
         onClick={() => {
           if (onClick) {
             onClick();
           } else {
             navigate(page);
           }
         }} >

      <span>{text}</span>
      {status === 'loading' && (
        <Spinner style={{
                   width: '20px',
                   height: '20px',
                   animation: 'spin 1s linear infinite',
                 }} />
      )}

      {status === 'error' && (
        <XIcon className='image'
               style={{width: '20px',
                       height: '20px',
                       fill: '#dd0000',
                      }} />
      )}

      {status === 'ok' && (
        <CheckIcon className='image'
                   style={{width: '20px',
                           height: '20px',
                           stroke: '#00bb00',
                           fill: 'transparent',
                          }} />
      )}

    </div>
  );
}

export default Tab;
